import React, { Component } from "react";
import arrPrev from '../../images/line-md_arrow-left.png';
import nextArrow from '../../images/line-md_arrow-right.png';
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import Slider from "react-slick";
import axios from "axios";
import CardTwo from "../cards/cardTwo.js";
import CardDiretta from "../cards/cardDiretta.js";



class DiretteCategorie extends Component{
  constructor(props){
    
    super(props);
      this.state = {
         activeSlide: 0, 
      }
      this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
     this.handleOpenPlayer = this.handleOpenPlayer.bind(this);
     this.handleAfterChange = this.handleAfterChange.bind(this); 
}

handleAfterChange(current) {
        this.setState({ activeSlide: current });
    }

next() {
  this.slider.slickNext();
}
previous() {
  this.slider.slickPrev();
}


getYouTubeVideoId(url) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}
 
  handleOpenPlayer(el){
   
    const videoId = this.getYouTubeVideoId(el.linkDiretta); // Sostituisci con l'ID del video desiderato
    this.props.onShowVideo(videoId); // Chiama la funzione di callback
  // callback al padre
  };

  render(){
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      centerMode: false,
      centerPadding: '60px',
      slidesToShow:1, 
      slidesToScroll: 1,
      variableWidth: true,
        afterChange: this.handleAfterChange, 
    };
    const { lista } = this.props;
    const {activeSlide} = this.state;
      const prevButtonClass = `buttonSlider left ${activeSlide === 0 ? 'hidden-button' : ''}`;
  return (
    <section className="categorysection">
    <div className="container">
    <div className="slider-wrapper">
    <div className="slider-title-wrapper">
      <h2 className="h2">{this.props.name}</h2>
    </div>
    <div className="slider-hover-wrapper">
    <div className="divButton ">
      <button className="buttonSlider left" onClick={this.previous}>
          <img className={prevButtonClass} height={51}  width={51} src={arrPrev}/>
          </button>
          <button className="buttonSlider right" onClick={this.next}>
          <img className="next-slick-arrow" src={nextArrow}  height={51}  width={51} />
          </button>
    </div>
    <div className="container-home slider-container" >
    <Slider ref={c => (this.slider = c)} {...settings}>
    {lista != null && lista?.map(el => (
      <div  onClick={() => this.handleOpenPlayer(el)} className="paddingRight5" key={"live"+el.id}>
    
    <CardDiretta  thumbnail={el.thumbnail} title={el.titolo_diretta} data={el.created_at} isHome={false} ></CardDiretta>
    
    </div>
    ))}
     </Slider>
   </div>
   </div>
   </div>
   </div>
   </section>
    )
}
}
export default DiretteCategorie; 





